import { render, staticRenderFns } from "./ex-prize.vue?vue&type=template&id=1fa649f2&scoped=true&"
import script from "./ex-prize.vue?vue&type=script&lang=js&"
export * from "./ex-prize.vue?vue&type=script&lang=js&"
import style0 from "./ex-prize.vue?vue&type=style&index=0&id=1fa649f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa649f2",
  null
  
)

export default component.exports